import { Tab } from '@/components/ui/tabs';
import { ResourceEntity } from '@/graphql/generated/graphql';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useKnowledgeHubStore } from '../store/useKnowledgeHubStore';
import { compare } from '../utils/compare.utils';

export default function useKnowledgeHub() {
  const { topics, highlights, onInit, onInitMain, filterActive, loading, page, resetFilter, loadingThemeContent } =
    useKnowledgeHubStore();
  const [tabs, setTabs] = useState<Tab[]>([]);
  const { topic: topicParam, theme: themeParam, slug } = useParams();

  useEffect(() => {
    if (topicParam) {
      onInit(topicParam, themeParam);
      return;
    }
    onInitMain();
  }, [onInit, onInitMain, topicParam, themeParam]);

  useEffect(() => {
    setTabs(() => {
      return [
        {
          attributes: {
            topic: topics?.length ? page?.page?.highlightTopicLabel || 'Highlights' : '',
          },
        },
        ...(topics || []),
      ]?.map((topic) => {
        let current;

        if (topicParam) {
          current = compare(topic?.attributes?.topic?.toString(), topicParam);
        }

        if (
          !topicParam &&
          compare(topic?.attributes?.topic?.toString(), page?.page?.highlightTopicLabel || 'Highlights')
        ) {
          current = true;
        }

        return {
          name: topic?.attributes?.topic?.toString() || '',
          href: compare(topic.attributes?.topic?.toString(), page?.page?.highlightTopicLabel || 'Highlights')
            ? '/knowledge-hub'
            : `/knowledge-hub/topic/${topic.attributes?.topic}`,
          onClick: () => {
            if (filterActive) resetFilter();
          },
          current,
        };
      }) as Tab[];
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterActive, slug, topicParam, topics]);

  const topic = topics?.find((topicRoot) => compare(topicRoot.attributes?.topic?.toString(), topicParam));
  const highlightsForTopic = (highlights[topicParam!] as ResourceEntity[]) || highlights[Object.keys(highlights)[0]];

  return {
    tabs,
    highlightsForTopic,
    topic,
    loading,
    slug,
    filterActive,
    page,
    setTabs,
    loadingThemeContent,
  };
}
